

// Lib imports
import Vue from 'vue'
//import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
//import Meta from 'vue-meta'

import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import Questionaire from '@/views/Questionaire.vue'
import Project from '@/views/Project.vue'
import NotFound from '@/views/404.vue';
import Toolbar from "@/components/core/Toolbar.vue"

// Routes
const routes = [
  
  {
    path: '',
    name: 'Home',
    components: {default : Home, navigation: Toolbar},
     secure: true,
    navbar: true
  },
  {
    path: '/project',
    name: 'Project',
    components: {default : Project},
    meta: {
      title: 'Projectplace',
      metaTags: [
        {
          name: 'description',
          content: 'The home page of our example app.'
        },
        {
          property: 'og:description',
          content: 'The home page of our example app.'
        }
      ]
    }
  },
  {
    path: '/project/:index',
    bane: 'ProjectIten',
    components: {default : Project},
     props: true,
  },
   {
    name: 'Lead',
    path: '/:source/:index',
    components: {default : Questionaire, navigation: Toolbar},
     props: true,
     secure: true,
    navbar: true
  },
  {
    name: 'LeadAsSupplier',
    path: '/:source/:index/:impersonate',
    components: {default : Questionaire, navigation: Toolbar},
     props: true,
     secure: true,
    navbar: true
  },
  {
    path: '/login',
    name: 'Login',
    components: {default : Login}
    },
    {
    path: '/logout',
    name: 'Logout',
    components: {default : Home}
    },
  {
    path: '/login/:token',
    components: {default : Login},
    name: "Autologin"
  },
   
  { path: '*', 
    name: "404",
    components: {default : NotFound}
   }
]


Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash !=='') {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title
  next()
})
//Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
/*if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development'
    }
  })
}*/

export default router
